import React, { useEffect, useState } from 'react';
import './CompassOrientation.css';

// LED state enum from compass.proto
const LedState = {
  LED_UNDEFINED: 0,
  LED_POWERING_ON: 1,
  LED_POWERING_OFF: 2,
  LED_POWERED_OFF: 3,
  LED_BATTERY_CHARGING: 4,
  LED_BATTERY_CHARGED: 5,
  LED_LID_CLOSED: 6,  // Legacy state - deprecated, use specific states below
  LED_LID_CLOSED_LOW_POWER: 7,
  LED_LID_CLOSED_HIGH_POWER_DIAL_CHARGING: 8,
  LED_LID_CLOSED_NIGHT_DIAL_CHARGING: 9,
  LED_LID_CLOSED_DAY: 10,
  LED_SHOW_TIME: 11,
  LED_SHOW_DIRECTION: 12,
  LED_OFF: 13
};

const CompassOrientation = ({ compassState }) => {
  const [directionsSvg, setDirectionsSvg] = useState(null);
  const [directionSvg, setDirectionSvg] = useState(null);
  const [compassSvg, setCompassSvg] = useState(null);
  const [dialSvg, setDialSvg] = useState(null);
  const [targetDialSvg, setTargetDialSvg] = useState(null);

  useEffect(() => {
    const loadSvg = async (url, setSvg) => {
      const response = await fetch(url);
      const svgText = await response.text();
      setSvg(svgText);
    };

    loadSvg('/directions.svg', setDirectionsSvg);
    loadSvg('/direction.svg', setDirectionSvg);
    loadSvg('/compass.svg', setCompassSvg);
    loadSvg('/dial.svg', setDialSvg);
    loadSvg('/targetDial.svg', setTargetDialSvg);
  }, []);

  if (!compassState) {
    return null;
  }

  let backgroundColor = '';
  switch (compassState.ledState) {
    case LedState.LED_BATTERY_CHARGING:
    case LedState.LED_SHOW_TIME:
    case LedState.LED_SHOW_DIRECTION:
    case LedState.LED_BATTERY_CHARGED:
    case LedState.LED_LID_CLOSED_HIGH_POWER_DIAL_CHARGING:
    case LedState.LED_LID_CLOSED_NIGHT_DIAL_CHARGING:
      backgroundColor = 'purple';
      break;
    case LedState.LED_LID_CLOSED_LOW_POWER:
    case LedState.LED_LID_CLOSED_DAY:
    case LedState.LED_OFF:
    case LedState.LED_UNDEFINED:
      backgroundColor = 'white';
      break;
  }
  const heading = compassState.imuState?.heading || 0;
  const currentAngle = compassState.motorState?.currentAngle || 0;
  const targetAngle = compassState.motorState?.targetAngle || 0;
  const direction = targetAngle - currentAngle; // Calculate direction as the difference between target and current angle

  return (
    <div className="compass-visualization" style={{ backgroundColor }}>
      <div
        className="svg-container directions-svg"
        dangerouslySetInnerHTML={{ __html: directionsSvg }}
      />
      <div
        className="svg-container svg-rotatable direction-svg"
        dangerouslySetInnerHTML={{ __html: directionSvg }}
        style={{ transform: `rotate(${direction}deg)` }}
      />
      <div
        className="svg-container svg-rotatable compass-svg"
        dangerouslySetInnerHTML={{ __html: compassSvg }}
        style={{ transform: `rotate(${heading}deg)` }}
      />
      <div
        className="svg-container svg-rotatable target-dial-svg"
        dangerouslySetInnerHTML={{ __html: targetDialSvg }}
        style={{ transform: `rotate(${targetAngle + heading}deg)` }}
      />
      <div
        className="svg-container svg-rotatable dial-svg"
        dangerouslySetInnerHTML={{ __html: dialSvg }}
        style={{ transform: `rotate(${currentAngle + heading}deg)` }}
      />
    </div>
  );
};

export default CompassOrientation;
